import React from 'react';
import { Link } from "react-router-dom";
import { 
  Card, 
  CardImg, 
  CardBody,
  CardTitle, 
  CardSubtitle 
} from 'reactstrap';
import LineQuene from '../../utils/images/LineQuene.png';
import SeatBelt from '../../utils/images/SeatBelt.png';
import Cellphone from '../../utils/images/Cellphone.png';
import WrongWay from '../../utils/images/WrongWay.jpeg';
import TrespassZebra from '../../utils/images/TrespassZebra.png';
import RedLight from '../../utils/images/RedLight.png';
import WrongTurn from '../../utils/images/WrongTurn.png';
import Speed from '../../utils/images/Speed.png';

import {buildMediaURL} from "../../actions/auth";

type Props = {
  handleChange?: (e:any,i:any)=> void,
  ViolationType:string,
  violationImage: string,
  vehicleSummary:string,
  violationDate:string,
  imageSource:string,
  id: string,
  backgroundColor: string,
  listType: string,
  borderLeft?: string
};


export const ViolationListItem = (props: Props) => (
  <div key={props.id} style={{backgroundColor: props.backgroundColor, paddingTop: '5px', paddingLeft: '10px', borderLeft: props.borderLeft}}>
    <div className="listedData" onClick={(e) => props.handleChange && props.handleChange(props.id,e)}>
    
    <Card style={{display: 'flex'}}>
       {/*<CardImg width="40%" src={buildMediaURL(props.imageSource)} />*/}
     <CardImg  loading="lazy" src={buildMediaURL(props.violationImage)} />
        <CardBody style={{width: "100%"}}>
          <CardSubtitle>{props.violationDate} </CardSubtitle>
            {/*<CardTitle><b>{props.vehicleSummary}</b>    </CardTitle> */}
          <CardTitle><b>Event Id: {props.id?props.id.substr(0,props.id.indexOf('_')):""}</b>    </CardTitle> 
          {renderSwitch(props.ViolationType)}
            {props.listType === 'recent' ? <Link id="viewVoilationPackage" to={{pathname: '/eventsHistory',state:{violationsListType: 'recent', targetkey: props.id}}}>View Violation Package</Link>: ''}
        </CardBody>
      </Card>

      </div>  
  </div>
)

const renderSwitch = (param: string) => {
  switch(param) {
    case 'cutlane':
      return (
          <div>
            <img src={LineQuene} id ="ViolationImage"/>
            <p id ="violationType">Queue Jumping</p>
          </div>
      );
    case 'runningredlight':
       return (
           <div>
            <img src={RedLight} id ="ViolationImage"/>
            <p id ="violationType">Red Light</p>
           </div>
       );
    case 'trespass_zebra':
       return (
           <div>
               <img src={TrespassZebra} id ="ViolationImage"/>
               <p id ="violationType">Trespass Zebra</p>
           </div>
       );
    case 'wrongturn':
    return (
        <div>
            <img src={WrongTurn} id ="ViolationImage"/>
            <p id ="violationType">Wrong Turn</p>
        </div>
    );
    case 'seatbelt':
    return (
        <div>
            <img src={SeatBelt} id ="ViolationImage"/>
            <p id ="violationType">SeatBelt</p>
        </div>
    );
    case 'cellphone':
    return (
        <div>
            <img src={Cellphone} id ="ViolationImage"/>
            <p id ="violationType">Cellphone</p>
        </div>
    );
    case 'wrongway':
      return (
        <div>
            <img src={WrongWay} id ="ViolationImage"/>
            <p id ="violationType">Wrong Way</p>
        </div>
    );
    case 'speed':
      return (
        <div>
            <img src={Speed} id ="ViolationImage"/>
            <p id ="violationType">Avg. Speed</p>
        </div>
    );
    case 'spotspeed':
      return (
        <div>
            <img src={Speed} id ="ViolationImage"/>
            <p id ="violationType">Spot Speed</p>
        </div>
    );
    default:
      return 'others';
  }
};



// WEBPACK FOOTER //
// ./src/components/Common/ViolationListItem.tsx